import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { useConfigService } from '@thd-nucleus/experience-context';
import { faqLegalCopy, getEnrolledGroupedFAQs, getUnenrolledGroupedFAQs } from '../../../constants/constants';
import { Section } from './section';

function FAQs({ apiResponse }) {
  const isTCChangesEnabled = !!useConfigService('ENABLE_TC_CHANGES');
  const enableHdPass = !!useConfigService('ENABLE_HD_PASS_VERBIAGE');

  const faqs = apiResponse?.enrollmentStatus === 'Y' ? getEnrolledGroupedFAQs(enableHdPass)
    : getUnenrolledGroupedFAQs(enableHdPass);
  return (
    <div id="faqs">
      {apiResponse && faqs.map((item, indx) => <Section key={item.title} section={item} index={indx} />)}
      <Typography variant="body-xs">{faqLegalCopy(isTCChangesEnabled)}</Typography>
    </div>
  );
}

FAQs.propTypes = {
  apiResponse: PropTypes.shape({
    enrollmentStatus: PropTypes.string,
    isMilitaryDiscountCapped: PropTypes.string,
    enrolledProfile: PropTypes.objectOf(PropTypes.string),
  }).isRequired,
};

export default FAQs;
